<script lang="jsx">
  import { computedPbxPlans, computedPbxCallingPlans } from '@/common/service/computers/plans/pbx';
  import {
    PBX_REGIONS_MAP_COUNTRY, PBX_REGIONS, PBX_GS
  } from '@/plans/ZOOM_PHONE/helper/constants';
  import GlobalEventTypes from '@/common/global-event-types';
  import configUK from './config-UK.vue';
  import configUS from './config-US.vue';
  import configJP from './config-JP.vue';
  import configGS from './config-GS.vue';
  import { mapGetters } from 'vuex';
  import { findKey } from '@/plans/ZOOM_PHONE/helper/utils';
import { persistCartConstant } from '@/views/config/shopping-cart/persist/persist-cart';
import _ from 'lodash';

  export default {
    components:{
      configUK,
      configUS,
      configJP,
      configGS
    },

    props: {
      configPlanTileStatus: {
        type: Object,
        default: () => ({}),
      },
    },
    computed: {
      ...mapGetters({
        'getSelectedPlans': 'getSelectedPlans',
        'pbxBaseInfo': 'pbxBaseInfo',
      }),
      selectedPbxPlans() {
        return computedPbxPlans(this.getSelectedPlans);
      },
      selectedRegion() {
        let region = findKey(PBX_REGIONS_MAP_COUNTRY,this.selectedPbxPlans.filter(item => item.region)[0]?.region);
        if (persistCartConstant.enablePersistShoppingBagForV2) {
          const selectedPbxCallingPlans = computedPbxCallingPlans(this.selectedPbxPlans);
          const selectedFirstCallingPlan = _.chain(selectedPbxCallingPlans).filter(item => item.region).get(0).value();
          region = findKey(PBX_REGIONS_MAP_COUNTRY, selectedFirstCallingPlan?.region) || region;
        }
        return region;
      },
      isGlobalSelect(){
        return this.selectedPbxPlans.some(item => PBX_GS.includes(item.category)) && this.$config('enableZoomPhoneGlobalSelect')
      },
      enableJPBuy(){
        return this.$config('enableZPJapanOnlineBuy');
      }
    },
    methods:{
      /**
       * Handle Zoom Phone billing cycle change
       * Delegates to child component to switch plans and refresh UI
       * @param {string} newCycle - New billing cycle (monthly/annual)
       */
      handlePbxBillingCycleChange(newCycle) {
        this.$nextTick(() => {
          const regionComponent = this.$refs?.pbxRegionComponent;
          // Switch plans to new billing cycle
          if(regionComponent?.switchPlansCycle && _.isFunction(regionComponent?.switchPlansCycle)) {
            regionComponent.switchPlansCycle?.([newCycle, this.pbxBaseInfo.basePlanCode], false);
          }

          // Force refresh components to display updated data
          if(regionComponent?.forceRefreshComponents && _.isFunction(regionComponent?.forceRefreshComponents)) {
            regionComponent.forceRefreshComponents?.();
          }
        });
      },
      /**
       * Handle external billing cycle change from other products
       * @param {Object} payload - { newCycle, oldCycle, source }
       */
      handleExternalBillingCycleChange(payload) {
        const { newCycle, oldCycle, source } = payload;
        console.log('[Zoom phone base cycle Event] External billing cycle change:', {
          source,
          oldCycle,
          newCycle
        });

        if (newCycle && oldCycle && newCycle !== oldCycle) {
          this.handlePbxBillingCycleChange(newCycle);
        }
      },
      renderRegions(){
        const propsContext = { configPlanTileStatus: this.configPlanTileStatus };
        const allContext = { ...this.$attrs, ...propsContext };
        if(this.isGlobalSelect && !this.$context.is.add2cart){
          return <configGS ref="pbxRegionComponent" {...allContext} />;
        }
        // for add2cart, reuse this module to config 3 regions at one time
        if(this.$context.is.add2cart) {
          const selectedRegion = [
            PBX_REGIONS.US_AND_CANADA,
            PBX_REGIONS.UK_AND_IRELAND,
            PBX_REGIONS.AUS_AND_NZ,
          ].includes(this.selectedRegion) && this.selectedRegion || PBX_REGIONS.US_AND_CANADA;
          return <configUK ref="pbxRegionComponent" region={selectedRegion} {...allContext} />;
        };

        switch (this.selectedRegion) {
          case PBX_REGIONS.JP:
            if(this.enableJPBuy  || this.$context.is.edit){
              return <configJP ref="pbxRegionComponent" region={PBX_REGIONS.JP} {...allContext} />;
            };
            return <configUS ref="pbxRegionComponent" {...propsContext}/>
          case PBX_REGIONS.UK_AND_IRELAND:
          return <configUK ref="pbxRegionComponent" region={PBX_REGIONS.UK_AND_IRELAND} {...allContext} />;
          case PBX_REGIONS.AUS_AND_NZ:
          return <configUK ref="pbxRegionComponent" region={PBX_REGIONS.AUS_AND_NZ} {...allContext} />;
          case PBX_REGIONS.US_AND_CANADA:
          return <configUS ref="pbxRegionComponent" {...allContext} />
          default:
            return <configUS ref="pbxRegionComponent" {...propsContext}/>
        }
      }
    },
    render() {
      return this.renderRegions()
    },
    created() {
      // Listen for external billing cycle changes from other products
      this.$context.$on(GlobalEventTypes.SYNC_PBX_STATE_WITH_BILLING_CYCLE, this.handleExternalBillingCycleChange, this);
    },
    beforeUnmount() {
      // Cleanup event listener
      this.$context.$off(GlobalEventTypes.SYNC_PBX_STATE_WITH_BILLING_CYCLE);
    }
  }
</script>
